/*--------------------------------------------------------------
# Custom scripts for Hero Complex slider
--------------------------------------------------------------*/

// Check if hero-complex section exists before running any code
if (document.querySelector('section.hero-complex')) {
    // Strictly scope all selectors to within hero-complex section
    const heroSection = document.querySelector('section.hero-complex');
    const heroComplexSliders = heroSection.querySelectorAll('.hero-complex-slider .swiper');
    const heroComplexSlidersPagination = heroSection.querySelectorAll('.hero-complex-slider .hero-complex-swiper-pagination');
    const carouselControls = heroSection.querySelectorAll('.carousel-control');

    // Initialize the players map to store Vimeo players for each iframe
    const playersMap = new Map();
    // Store Swiper instances
    const swiperInstances = [];

    heroComplexSliders.forEach((heroSlider, index) => {
        // Add unique class for the main slider
        const uniqueClass = `hero-complex-swiper-${index}`;
        heroSlider.classList.add(uniqueClass);
        heroComplexSlidersPagination[index].classList.add(`hero-complex-pagination-${index}`);

        // Initialize the main slider
        const mainSlider = new Swiper(heroSection.querySelector(`.${uniqueClass}`), {
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            touchEventsTarget: 'pointer',
            speed: 1500,
            // autoplay: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? {
            //     delay: 8000,
            // } : false,
            autoplay: {
                delay: 8000,
            },
            pagination: {
                el: heroSection.querySelector(`.hero-complex-pagination-${index}`),
                clickable: true,
                bulletElement: 'span',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                },
            },
            navigation: {
                nextEl: heroSection.querySelector('.hero-complex-swiper-next'),
                prevEl: heroSection.querySelector('.hero-complex-swiper-prev'),
            },
            on: {
                init: function () {
                    // Initialize all Vimeo players on slider load
                    const allIframes = heroSection.querySelectorAll('.hero-complex-slider iframe');
                    allIframes.forEach(iframe => {
                        if (!playersMap.has(iframe)) {
                            const player = new Vimeo.Player(iframe);
                            playersMap.set(iframe, player);

                            // Set initial quality and other options
                            player.setVolume(0);
                            player.setQuality('1080p');
                        }
                    });
                },
                slideChange: function () {
                    const allSlides = this.slides;

                    // Pause all videos and remove playing class
                    allSlides.forEach(slide => {
                        const iframe = slide.querySelector('iframe');
                        const videoTag = slide.querySelector('video');

                        // Handle Vimeo videos
                        if (iframe && playersMap.has(iframe)) {
                            const player = playersMap.get(iframe);
                            player.pause();
                            iframe.classList.remove('is-playing');
                        }

                        // Handle HTML5 videos
                        if (videoTag) {
                            // videoTag.pause();
                            videoTag.currentTime = 0;
                        }
                    });

                    // Play video on the active slide
                    const activeSlide = this.slides[this.activeIndex];
                    const activeIframe = activeSlide.querySelector('iframe');
                    const activeVideoTag = activeSlide.querySelector('video');

                    // Play Vimeo video
                    if (activeIframe && playersMap.has(activeIframe)) {
                        const player = playersMap.get(activeIframe);
                        activeIframe.classList.add('is-playing');
                        player.setCurrentTime(0)
                            .then(() => player.play())
                            .catch(error => {
                                activeIframe.classList.remove('is-playing');
                                console.error('Vimeo playback error:', error);
                            });
                    }

                    // Play HTML5 video
                    if (activeVideoTag) {
                        activeVideoTag.currentTime = 0; // Restart from the beginning
                        activeVideoTag.play();
                    }
                }
            }
        });

        // Store the Swiper instance
        swiperInstances[index] = mainSlider;
    });

    // Add play/pause functionality for the carousel
    carouselControls.forEach((control, index) => {
        control.addEventListener('click', () => {
            const swiperInstance = swiperInstances[index];
            if (swiperInstance) {
                if (control.classList.contains('paused')) {
                    // Resume autoplay
                    swiperInstance.autoplay.start();
                    control.classList.remove('paused');
                } else {
                    // Pause autoplay
                    swiperInstance.autoplay.stop();
                    control.classList.add('paused');
                }
            }
        });
    });
}
